<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["WD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MUN"]}} :</label>
                                            <CInput size="sm"
                                                    disabled
                                                    :value="obj_aw.U" @change="v => obj_aw.U = v" />
                                        </CCol>
                                        <CCol col="5" v-if="obj_aw.CI == 106 && obj_aw.IFSC != ''">
                                            <label class="col-form-label-sm">IFSC* :</label>
                                            <CInput size="sm" :value="obj_aw.IFSC" @change="v => obj_aw.IFSC = v" disabled />

                                            <!-- <span class="ErrMsg">{{ ValidationErrMsg('MB','IFSC') }}</span> -->
                                        </CCol>
                                    </CRow>
                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MB"]}}* :</label>
                                            <CInput size="sm" :value="obj_aw.MB" @change="v => obj_aw.MB = v" disabled />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MB','MB') }}</span>
                                        </CCol>

                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MAN"]}}* :</label>
                                            <CInput size="sm" :value="HideInfo(getUserInfo.IHMI, obj_aw.MBA, 4)" disabled />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MBA','MAN') }}</span>
                                        </CCol>
                                    </CRow>


                                    <CRow>
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["MANO"]}}* :</label>
                                            <CInput size="sm" :value="HideInfo(getUserInfo.IHMI, obj_aw.MBN, 4)" disabled />
                                            <span class="ErrMsg">{{ ValidationErrMsg('MBN','MANO') }}</span>
                                        </CCol>

                                        <CCol col="5">
                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}* : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                            <CInput disabled
                                                    :prepend="obj_aw['CS']"
                                                    size="sm"
                                                    :value="ThousandSeparator(obj_aw.TA, getThousandCurrency ? 3 : 2)"
                                                    @change="v => obj_aw.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                            <span class="ErrMsg">{{ ValidationErrMsg('TA','TA') }}</span>
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="obj_aw.PaymentGatewayList==null">
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage['MTA']['CAD']}}<span v-if="obj_aw.TM == 0 && !bool_OCAD">*</span> :</label>
                                            <CButton size="sm" color="outline-info" style="float: right;" @click="addBank()"><span class='plusIcon cil-plus'></span>{{this.getLanguage["BTN"]["AN"]}}</CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, obj_aw.CS ) }}</span>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:0%;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width:0%;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th style="width:35%;">{{this.getLanguage['MTA']['BKN']}}</th>
                                                            <th style="width:40%;">{{this.getLanguage['MTA']['BAN']}}</th>
                                                            <th style="width:25%;" class="tableCtnRight">{{this.getLanguage['MTA']['TA']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_aw.BankList == 0 || !obj_aw.BankList">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-for="(data,index) in obj_aw.BankList">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removeBank(index)'></i> <!--here Remove -->
                                                                <i class="cil-color-border" @click='editBank(data,index)'></i> <!--here Edit -->
                                                            </span>
                                                        </td>
                                                        <td>{{ index+1 }}</td>
                                                        <td>{{data.BN}}</td>
                                                        <td>{{data.BA}}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(data.TA, 2, obj_aw.CS) }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                            <span class="ErrMsg">{{ ErrBAAmount }}</span>
                                        </CCol>
                                        <CCol col="5">

                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RURL"]}} :</label>
                                            <div style="display:block;" class="mb-2">
                                                <input type="file" name="pic" accept="image/*, .pdf" @change="onFileSelected" style="overflow: hidden;" />
                                            </div>
                                            <!-- <span class="ErrMsg">{{ ValidationErrMsg('RURL','RURL') }}</span> -->

                                            <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                            <Textarea vertical="" rows="7" class="form-control form-control-sm" :value="obj_aw.R" @change="TextValueChange('R',$event)" v-shortkey.avoid />
                                        </CCol>
                                    </CRow>
                                    <CRow v-if="bool_supprotPM && (obj_aw.BankList==null|| obj_aw.BankList.length == 0 || !obj_aw.BankList)">
                                        <CCol col="7">
                                            <label class="col-form-label-sm">{{this.getLanguage['MTA']['PGD']}}* :</label>
                                            <CButton v-if="obj_aw.PaymentGatewayList==null" size="sm" color="outline-info" style="float: right;" @click="addPaymentgateway()"><span class='plusIcon cil-plus'></span>{{this.getLanguage['MTA']['APG']}}</CButton>
                                            <CRow style="padding-top: 20px;padding-left: 15px;display: block;">
                                                <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, obj_aw.CS ) }}</span>
                                                <table class="custom-table custom-table-inPopUp afb-blue">
                                                    <thead>
                                                        <tr>
                                                            <th style="width:0%;">{{this.getLanguage['GL']['ACT']}}</th>
                                                            <th style="width:0%;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                            <th style="width:35%;">{{this.getLanguage['MTA']['PG']}}</th>
                                                            <th style="width:40%;">{{this.getLanguage['MTA']['MC']}}</th>
                                                            <th style="width:40%;">{{this.getLanguage['MTA']['PD']}}</th>
                                                            <th style="width:25%;" class="tableCtnRight">{{this.getLanguage['MTA']['TA']}}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                    <td colspan="100%" v-if="obj_aw.PaymentGatewayList ==null || !obj_aw.PaymentGatewayList">{{this.getLanguage['GL']['NR']}}</td>
                                                    <tr v-if="!(obj_aw.PaymentGatewayList == null || !obj_aw.PaymentGatewayList)">
                                                        <td>
                                                            <span id="actionBtnCol">
                                                                <i class="cil-trash" @click='removePaymentGateway(obj_aw.PaymentGatewayList)'></i> <!--here Remove -->
                                                                <i class="cil-color-border" @click='editPaymentGateway(obj_aw.PaymentGatewayList)'></i> <!--here Edit -->
                                                            </span>
                                                        </td>
                                                        <td>{{ 1 }}</td>
                                                        <td>{{obj_aw.PaymentGatewayList.PMN}}</td>
                                                        <td>{{obj_aw.PaymentGatewayList.MC }}</td>
                                                        <td>{{obj_aw.PaymentGatewayList.BC}}</td>
                                                        <td class="tableCtnRight">{{ formatNumber(obj_aw.PaymentGatewayList.TA, 2, obj_aw.CS) }}</td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </CRow>
                                        </CCol>
                                    </CRow>
                                </div>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton v-shortkey="['enter']" @shortkey="approveWithdraw()" color="outline-success" size="sm" @click="approveWithdraw()">
                                        {{this.getLanguage['GL']['APR']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>

                </div>
            </transition>
        </div>

        <div v-if="bool_isABA">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:50%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["MTA"]["CAD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddBank()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BKN"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bank"
                                                    v-model="obj_bank['BNI']"
                                                    @input="BankNameChange($event, false)"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BNI','BKN') }}</span>
                                    </CCol>
                                    <CCol col="6" v-if="bool_showTDTL">
                                        <label class="col-form-label-sm">{{this.getLanguage["BANK"]["TDTL"]}} : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <div role="group" class="form-group">
                                            <div class="input-group input-group-sm">
                                                <div class="input-group-prepend">
                                                    <span class="input-group-text">{{obj_aw['CS']}}</span>
                                                </div>
                                                <span class="form-control" v-html="str_TotalDailyTransactionLimit"></span>
                                            </div>
                                        </div>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["BAN"]}}* : </label>
                                        <treeselect :multiple="false"
                                                    :options="dd_bankacc"
                                                    v-model="obj_bank['BAI']"
                                                    @input="BankAccountChange($event)"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('BAI','BAN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}* : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, obj_aw.CS ) }}</span>
                                        <CInput :prepend="obj_aw['CS']"
                                                size="sm"
                                                :readonly="obj_bank.IAW"
                                                :value="ThousandSeparator(obj_bank.TA, getThousandCurrency ? 3 : 2)"
                                                @change="v => obj_bank.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                        <span class="ErrMsg">{{ ValidationBankErrMsg('TA','TA') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow v-if="IsAllowAutoWithdraw">
                                    <CCol col="6">
                                        <label class="switch">
                                            <input type="checkbox" v-model="obj_bank.IAW" @change="changeAllowAutoWithdraw">
                                            <span class="slider round"></span>
                                        </label>
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["IAW"]}}</label>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveBank()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isPM">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:50%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{getLanguage["MTA"]["PGD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAddPaymentgateway()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["PG"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_PaymentMethod"
                                                    v-model="obj_PaymentMethod['PMI']"
                                                    @input="PaymentMethodChange($event, false)"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationPMBankErrMsg('PMI','PG') }}</span>
                                    </CCol>

                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["MC"]}} :</label>
                                        <CInput disabled
                                                size="sm"
                                                :value="obj_PaymentMethod['MC']" />

                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{getLanguage["MTA"]["PD"]}}* : </label>
                                        <treeselect :multiple="false"
                                                    :options="dd_PMbankacc"
                                                    v-model="obj_PaymentMethod['BC']"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationPMBankErrMsg('BC','PD') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["TA"]}}* : <span class="amountNote" v-if="getThousandCurrency">{{getLanguage["GL"]["CUR"]}}</span></label>
                                        <span class="RAMsg">{{this.getLanguage["MTA"]["RA"]}} : {{ CalculateRemainAmount( obj_aw.TA, obj_aw.CS ) }}</span>
                                        <CInput disabled
                                                :prepend="obj_aw['CS']"
                                                size="sm"
                                                :value="ThousandSeparator(obj_PaymentMethod.TA, getThousandCurrency ? 3 : 2)"
                                                @change="v => obj_PaymentMethod.TA = RemoveThousandSeparator(v, getThousandCurrency ? 3 : 2)" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_PaymentMethod['PMI'] === '46'">
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{ getLanguage["MTA"]["PA"] }}* : </label>
                                        <treeselect :multiple="false"
                                                    :options="dd_FPGPaymentAcc"
                                                    v-model="obj_PaymentMethod['FPGACC']"
                                                    :clearable="false" />
                                        <span class="ErrMsg">{{ ValidationPMBankErrMsg('BC', 'PD') }}</span>
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="savePaymentGateway()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isRMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["MTA"]["RD"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeReject()">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["MEM"]["U"]}} :</label>
                                        <CInput size="sm"
                                                disabled
                                                v-model="obj_aw['U']" />
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["RR"]}}* :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_rejectreason"
                                                    :placeholder="getLanguage['MTA']['RR']"
                                                    v-model="obj_Reject.reason"
                                                    :limit="1"
                                                    :limitText="count => `+${count}`" />
                                    </CCol>
                                </CRow>
                                <CRow v-if="obj_Reject.reason==999">
                                    <CCol col="12">
                                        <CInput class="margint10" :placeholder="getLanguage['MTA']['RR']+'* :'" size="sm" :value="obj_Reject.reason2" @change="v => obj_Reject.reason2 = v" :disabled="obj_Reject.reason!=999" maxlength="300"></CInput>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <span class="ErrMsg">{{ ValidationErrMsg('RR','RR') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="12">
                                        <label class="col-form-label-sm">{{this.getLanguage["MTA"]["R"]}} :</label>
                                        <Textarea vertical="" rows="7" class="form-control form-control-sm" :value="obj_aw.R" @change="TextValueChange('R',$event)" v-shortkey.avoid />
                                    </CCol>
                                </CRow>

                                <div style="text-align:center;margin-top:20px">
                                    <CButton v-shortkey="['enter']" @shortkey="rejectWithdraw()" color="outline-danger" size="sm" @click="rejectWithdraw()">
                                        {{this.getLanguage['GL']['REJ']}}
                                    </CButton>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showDetails">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage['GL']['D']}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showDetails = !bool_showDetails">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol col="6">
                                            <div class='searchCol'>
                                                <span class='searchLabel' v-if="checkDetails==1">{{this.getLanguage['GL']['PDGMT']}}</span>
                                                <span class='searchLabel' v-else>{{this.getLanguage['GL']['LDDGMT']}}</span>
                                                <CInput size="sm"
                                                        :value="searchCreatedTS.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                        disabled />
                                            </div>
                                        </CCol>
                                        <CCol col="6">
                                            <div class='searchCol'>
                                                <span class='searchLabel'>{{this.getLanguage['GL']['WDGMT']}}</span><br />
                                                <CInput size="sm"
                                                        :value="searchCreatedTS.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                        disabled />
                                            </div>
                                        </CCol>
                                    </CRow>
                                    <div style="height:400px">
                                        <div>
                                            <header class="table-header" style="top: -20px">
                                                <strong>{{this.getLanguage['MEM']['CKMT']}}</strong>
                                                <div class="pageBtn" v-if="bool_showAllTransaction">
                                                    <button @click="prevPage()">
                                                        <span class="arrowLeft"></span>
                                                    </button>
                                                    <input class="page-control"
                                                           v-model="int_Page"
                                                           type="number"
                                                           @keyup="int_Page = int_Page" />
                                                    <span class="tableItemCount">/ {{int_TP}}</span>
                                                    <button @click="nextPage()">
                                                        <span class="arrowRight"></span>
                                                    </button>
                                                </div>
                                            </header>
                                            <table class='custom-table afb-blue'>
                                                <thead>
                                                    <tr>
                                                        <th style="top:30px">
                                                            {{this.getLanguage['MEM']['CKMPVD']}}
                                                        </th>
                                                        <th class="tableCtnRight" style="top:30px">
                                                            {{this.getLanguage['MEM']['CKMWL']}}
                                                        </th>
                                                        <th class="tableCtnRight" style="top:30px">
                                                            {{this.getLanguage['MEM']['TO']}}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-if="arr_TransactionList.length == 0">
                                                        <td colspan="10">{{this.getLanguage['GL']['NR']}}</td>
                                                    </tr>
                                                    <tr v-for="(data,index) in arr_TransactionList">
                                                        <td>
                                                            <router-link :to="{ path:'/R/WINLV2', query:{ gpi: data.GPI, as: 't', i: obj_member.I, u: obj_member.U, df: searchCreatedTS.startDate,dt:searchCreatedTS.endDate }}" target="_blank">
                                                                <b>{{utilGetErrorLanguage('GP.' + data.PN)}}</b>
                                                            </router-link>
                                                        </td>
                                                        <td :class="data.WLA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.WLA, 2, data.CS) }}</td>
                                                        <td :class="data.TA >= 0? 'positive-number tableCtnRight': 'negative-number tableCtnRight'">{{ formatNumber(data.TA, 2, data.CS) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_fullPreview">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["GL"]["P"]}}</h4>
                                    </CCol>
                                    <CCol col="4">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd1">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content text-center">
                                    <img :src="previewUrl" class="img-fluid" v-if="previewUrl">
                                    <p v-else>{{this.getLanguage['GL']['NR']}}</p>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_isDDMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow" style="max-width: 450px;">
                        <CCard>
                            <CCardBody class="modal-body" id="modalDescription">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["R"]["CSL"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_isDDMV = false">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <div class="text-right">
                                        <CButton class="mb-1 btnReset" @click="resetColumn()" v-if="needResetHeaders">
                                            <span class="font-weight-bold cil-reload"></span>
                                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                                        </CButton>
                                    </div>

                                    <draggable v-model="reportHeaders" tag="ul" class="p-0 mb-0 sorttable">
                                        <li v-for="header in reportHeaders" :key="header" scope="col" class="list-group-item p-2">
                                            <template v-if="header == 'NO'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["NO"]}}
                                            </template>
                                            <template v-else-if="header == 'TN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["GL"]["TNO"]}}
                                            </template>
                                            <template v-else-if="header == 'BN'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["BN"]}}
                                                <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'U'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MEM"]["U"]}}
                                                <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                            </template>
                                            <!--<template v-else-if="header == 'TSID'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                                <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                            </template>-->
                                            <template v-else-if="header == 'MBA'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["MAD"]}}
                                            </template>
                                            <template v-else-if="header == 'TA'" class="tableCtnRight d-block">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["TA"]}} / {{getLanguage["MTA"]["EA"]}}
                                                <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                            </template>
                                            <template v-else-if="header == 'OWN' && checkModuleAccess2(constAccessType.add)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["OWN"]}}
                                            </template>
                                            <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.add)">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["RS"]}}
                                            </template>
                                            <template v-else-if="header == 'CTS'">
                                                <i class="fa fa-times" @click="removeColumn(header)"></i>
                                                {{getLanguage["MTA"]["RT"]}}
                                                <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                            </template>
                                        </li>
                                    </draggable>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{this.getLanguage["SMB"]["SWDU"]}}</h2>
                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["BN"]}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroup"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  @input="AgentGroupChangefs"
                                                  v-model="str_FV[0].FV" />
                            </div>
                            <!--<div class='searchCol'>
                            <span class='searchLabel'>{{this.getLanguage["MEM"]["U"]}} :</span>
                            <treeselect :multiple="false"
                                        :async="true"
                                        :load-options="loadMemberOptions"
                                        :options="ddMemberList"
                                        :cacheOptions="false"
                                        :disable-branch-nodes="true"
                                        :searchPromptText="this.getLanguage['GL']['DDTS']"
                                        :placeholder="this.utilGetDDLanguage('MEM.U')"
                                        v-model="str_FV[3].FV" />
                        </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <!--<div class='searchCol'>
                            <span class='searchLabel'>{{this.getLanguage["MTA"]["DN"]}} :</span>
                            <treeselect :multiple="false"
                                        :options="dd_dofs"
                                        :placeholder="this.utilGetDDLanguage('MTA.DN')"
                                        :noOptionsText="this.getLanguage['GL']['NOA']"
                                        v-model="str_FV[1].FV" />
                        </div>-->
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["MTA"]["C"]}} :</span>
                                <treeselect :multiple="true"
                                            :limit="1"
                                            :limitText="count => `+${count}`"
                                            :options="dd_currency"
                                            :placeholder="this.utilGetDDLanguage('MTA.C')"
                                            v-model="str_FV[6].FV" />
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{this.getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>
        </div>
        <div class="container-fluid">
            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']['SWDU']}}</strong>
                    <div class="pageBtn">
                        <CButton class="btnReset" @click="bool_isDDMV = true"><span class="fa-solid fa-up-down"></span>{{this.getLanguage['R']['CS']}}</CButton>
                        <CButton class="btnReset" @click="resetColumn()" v-if="needResetHeaders">
                            <span class="font-weight-bold cil-reload"></span>
                            {{this.getLanguage["DM"]["RST"]}}  {{this.getLanguage["BTN"]["COL"]}}
                        </CButton>
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["TNO"]}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["BN"]}}
                                        <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["U"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <!--<template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>-->
                                    <template v-else-if="header == 'MBA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["MAD"]}}
                                    </template>
                                    <template v-else-if="header == 'TA'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["TA"]}} / {{getLanguage["MTA"]["EA"]}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'OWN' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["OWN"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["RS"]}}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["RT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue' style="min-height: 150px;">
                        <thead>
                            <draggable v-model="reportHeaders" tag="tr">
                                <th v-for="header in reportHeaders" :key="header" scope="col" :class="renderClassName(header)">
                                    <template v-if="header == 'NO'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["NO"]}}
                                    </template>
                                    <template v-else-if="header == 'TN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["GL"]["TNO"]}}
                                    </template>
                                    <template v-else-if="header == 'BN'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["BN"]}}
                                        <i @click="setSortTable('GPC')" :class="setSortLogo('GPC')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'U'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MEM"]["U"]}}
                                        <i @click="setSortTable('U')" :class="setSortLogo('U')" class="sortlogo"></i>
                                    </template>
                                    <!--<template v-else-if="header == 'TSID'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        <span style="color: darkorange; font-weight: bold; ">{{getLanguage['MEM']['TSID']}}</span> /
                                        <span style="color: red; font-weight: 900;">{{getLanguage['MEM']['SU']}}</span>
                                    </template>-->
                                    <template v-else-if="header == 'MBA'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["MAD"]}}
                                    </template>
                                    <template v-else-if="header == 'TA'" class="tableCtnRight d-block">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["TA"]}} / {{getLanguage["MTA"]["EA"]}}
                                        <i @click="setSortTable('TA')" :class="setSortLogo('TA')" class="sortlogo"></i>
                                    </template>
                                    <template v-else-if="header == 'OWN' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["OWN"]}}
                                    </template>
                                    <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.add)">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["RS"]}}
                                    </template>
                                    <template v-else-if="header == 'CTS'">
                                        <i class="fa fa-times" @click="removeColumn(header)"></i>
                                        {{getLanguage["MTA"]["RT"]}}
                                        <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i>
                                    </template>
                                </th>
                            </draggable>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_wl.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_wl" :class="data.MS == 1? 'blacklist-row': ''">
                            <td v-for="header in reportHeaders" :key="header" :class="renderClassName(header)">
                                <template v-if="header == 'NO'">
                                    {{ CountItem(index+1) }}
                                </template>
                                <template v-else-if="header == 'TN'">
                                    {{ data.AGTI }}
                                </template>
                                <template v-else-if="header == 'BN'">
                                    <span class="grid-line">{{ data.GN }} ({{ data.GPC }})</span>
                                    <span class="saggroupname" v-if="data.SAGPC != ''">{{ data.SAGGN }} ({{ data.SAGPC }})</span>
                                    <span class="grid-line">{{ data.DN }}</span>
                                </template>
                                <template v-else-if="header == 'U'">
                                    <div v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <!--<div class="float-right ml-1">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16">
            <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
        </svg>
    </div>-->
                                    </div>
                                    <div v-if=" (isSENS == 1 && data.AGI != curAGI)">
                                        <div class="custom_tooltip">
                                            <span :style="getbgtooltip(data)" @click.stop>{{data.U}}</span>
                                            <span v-if="convertToBool(data.TN)" class="tooltiptext tooltip-right" :style="getbgtooltip(data)">{{data.TN}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.TW == 0">
                                            <img src="/src/assets/icons/nerverwithdraw.svg" class="nwithdraw-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["MNM"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.HTWT">
                                            <img src="/src/assets/icons/newtransfer.svg" class="ntransfer-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["PVP"]}}</span>
                                        </div>
                                        <div class="custom_tooltip" v-if="data.RP">
                                            <img src="/src/assets/icons/referral.svg" class="referral-icon" />
                                            <span class="tooltiptext tooltip-right">{{getLanguage["MTA"]["RFB"]}}</span>
                                        </div>
                                        <div class="float-right ml-1">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-arrow-right-circle-fill" viewBox="0 0 16 16" ">
                                                <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z" />
                                            </svg>
                                        </div>
                                    </div>
                                </template>
                                <!--<span v-else-if="header == 'TSID'">
                                    <span style="text-align:center;display:block">
                                        <span v-if="data.TSI > 0 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="getSystemId(data)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                            <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                        </span>
                                        <span v-else-if="data.TSI > 0 && (isSENS == 1 && data.AGI != curAGI)" :class="{opened: opened.includes(data.I)}" class="pointer">
                                            <span style="color:darkorange">({{ data.TSI }})</span> / <span style="color:red">({{ data.TMEM }})</span>
                                        </span>
                                        <span class="grid-line" v-else>-</span>
                                        <table class='p-4 mt-2' v-if="opened.includes(data.I)" style="width: 100%; background: #ebedef">
                                            <thead>
                                                <tr>
                                                    <th>{{ getLanguage['LOGRPT']['SI'] }}</th>
                                                    <th>{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <template v-for="(row,index1) in arry_systemId[data.I]">
                                                    <tr style="text-align: left;">
                                                        <td :style="[row.MI>0?{'cursor':'pointer'}:{}]" @click="row.MI>0?toggleFingPrintId(row,index,index1):{}" :class="{opened: opened.includes(index+'_'+index1)}">{{ row.SI }} <span style="color:red" v-if="row.MI>0">({{row.MI}})</span></td>
                                                        <td>{{ formatDateTime(row.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                    </tr>
                                                    <tr v-if="opened.includes(index+'_'+index1)" style="background: darkred">
                                                        <td colspan="2" style="padding:2px">
                                                            <table class='p-4' style="width: 100%; background: #ebedef;margin-top:1px">
                                                                <thead>
                                                                    <tr>
                                                                        <th style="background: darkgoldenrod;padding:0.25rem">{{getLanguage['GL']['NO']}}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['ACC'] }}</th>
                                                                        <th style="background: darkgoldenrod; padding: 0.25rem">{{ getLanguage['LOGRPT']['DT'] }}</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr v-for="(item,index) in arry_visitorMembers[index+'_'+index1]" style="text-align:left">
                                                                        <td style="text-align:center">{{ CountItem(index+1) }}</td>
                                                                        <td>
                                                                            <router-link :to="{ path:'/M/MCMI', query:{ agi: item.AGI, i: item.MI, u: item.UB, cf: 7}}" target="_blank">{{ item.UB }}</router-link>
                                                                        </td>
                                                                        <td style="text-align: right;">{{ formatDateTime(item.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                        </td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </span>
                                </span>-->
                                <template v-else-if="header == 'MBA'">
                                    <div class="custom_tooltip" style="float:left">
                                        <span class="grid-line">{{ data.AB }}</span>
                                        <span class="grid-line">{{ data.ABA }}</span>
                                        <span class="grid-line" :class="data.RS == 4 ? 'warninglist-row' : data.IB ? 'highrisk-row':''">{{ data.ABN }}</span>
                                        <!--<span class="grid-line">{{ HideInfo(getUserInfo.IHMI, data.ABA, 4) }}</span>-->
                                        <!--<span class="grid-line" :class="data.RS == 4 ? 'warninglist-row' : data.IB ? 'highrisk-row':''">{{ HideInfo(getUserInfo.IHMI, data.ABN, 4) }}</span>-->
                                        <span v-if="data.IB" class="tooltiptext" style="background:red">{{getLanguage['BANK']['SBA']}}</span>
                                        <span v-if="data.CI == 106 && data.IFSC != ''">{{ data.IFSC }}</span>
                                    </div>
                                    <!--<div v-if="data.MBQRC" style="float:right">
                                    <img class="card-img-top h-100" style="width: 50px; cursor: pointer;" alt="member-bank-qrcode" @click="setPreview(data.MBQRC)" :src="data.MBQRC" />
                                </div>-->
                                </template>
                                <template v-else-if="header == 'TA'">
                                    <div v-if="((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)">
                                        <span class="grid-line">
                                            <span>
                                                <span style="color:red">{{ formatNumber(data.TA, 2, data.CS) }}</span> / {{ formatNumber(data.EA, 2, data.CS) }}
                                            </span>
                                            <!--<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                        </svg>-->
                                        </span>
                                        <span class="grid-line" v-if="data.PM == 7"> {{ data.R }}</span>
                                        <!--<span class="grid-line" :style="renderStatusStyle(data.TA, data.EA)">({{ data.TA > data.EA ? getLanguage["MTA"]["ICTO"] : getLanguage["MTA"]["CTO"]}})</span>-->
                                    </div>
                                    <div v-else-if="(isSENS == 1 && data.AGI != curAGI)">
                                        <span class="grid-line">
                                            <span>
                                                {{ formatNumber(data.TA, 2, data.CS) }} / {{ formatNumber(data.EA, 2, data.CS) }}
                                            </span>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-plus-circle-fill" viewBox="0 0 16 16">
                                                <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3v-3z" />
                                            </svg>
                                        </span>
                                        <span class="grid-line" v-if="data.PM == 7"> {{ data.R }}</span>
                                        <!--<span class="grid-line" :style="renderStatusStyle(data.TA, data.EA)">({{ data.TA > data.EA ? getLanguage["MTA"]["ICTO"] : getLanguage["MTA"]["CTO"]}})</span>-->
                                    </div>
                                </template>
                                <template v-else-if="header == 'OWN' && checkModuleAccess2(constAccessType.add)">
                                    <div v-if="data.RS == 4">{{renderAssignedTo(data.AT, data.ATPC)}}</div>
                                    <CDropdown :ref="'dd_assignto_' + index"
                                               :toggler-text="renderAssignedTo(data.AT, data.ATPC)"
                                               :color="renderAssignedToColor(data.AT)"
                                               size="sm"
                                               class="m-1 d-inline-block"
                                               v-if="data.RS ==1 ">
                                        <CDropdownItem v-if="data.RS != 4 && data.canTakeover && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="assignWithdrawRequest(true,data,index)">{{getLanguage['PM']['TAKE']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.canTakeover && (isSENS == 1 && data.AGI != curAGI)">{{getLanguage['PM']['TAKE']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.canHandover && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="assignWithdrawRequest(false,data,index)">{{getLanguage['PM']['HAND']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.canHandover && (isSENS == 1 && data.AGI != curAGI)">{{getLanguage['PM']['HAND']}}</CDropdownItem>
                                    </CDropdown>
                                </template>
                                <template v-else-if="header == 'RS' && checkModuleAccess2(constAccessType.add)">
                                    <CDropdown :ref="'dd_status_' + index"
                                               :toggler-text="renderStatus(data.Status)"
                                               :color="renderStatusColor(data.Status)"
                                               size="sm"
                                               class="m-1 d-inline-block"
                                               v-if="data.canUpdateStatus">
                                        <CDropdownItem v-if="data.RS != 4 && data.PM != 7 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="changeApproval(true,data,index)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM != 7 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="changeApproval(false,data,index)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM == 7 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="changeCryptoApproval(true,data,index)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM == 7 && ((isSENS == 1 && data.AGI == curAGI) || isSENS == 0)" @click="changeCryptoApproval(false,data,index)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM != 7 && (isSENS == 1 && data.AGI != curAGI)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM != 7 && (isSENS == 1 && data.AGI != curAGI)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM == 7 && (isSENS == 1 && data.AGI != curAGI)">{{getLanguage['GL']['APR']}}</CDropdownItem>
                                        <CDropdownItem v-if="data.RS != 4 && data.PM == 7 && (isSENS == 1 && data.AGI != curAGI)">{{getLanguage['GL']['REJ']}}</CDropdownItem>
                                    </CDropdown>
                                    <div v-else>{{ data.RS == 4 ? getLanguage['PM']['PDP']:"-" }}</div>
                                </template>
                                <template v-else-if="header == 'CTS'">
                                    <span class="grid-line">{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</span>
                                    <span class="grid-line"><router-link :to="{ path:'/M/ML/SameTransactionIP', query:{ ip: data.TIP}}">{{ data.TIP }}</router-link></span>
                                </template>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import { mapGetters, mapActions } from 'vuex'
    import DateRangePicker from 'vue2-daterange-picker'
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import Loading from 'vue-loading-overlay';
    import { required, requiredIf, decimal } from 'vuelidate/lib/validators'
    import genericHelper from "@/modules/GenericHelper.js";
    import moment from "moment";
    import { constAccessType, constRejectReasonSW, loadingFullScreen, constADBBankSupportChannels, constADBBankAccountBalanceLimit } from '@/modules/Constant.js';
    import Vue from 'vue'
    import $ from 'jquery'
    import Sortable from 'sortablejs';
    import draggable from 'vuedraggable';
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            DateRangePicker,
            Treeselect,
            customtreeselect,
            Loading,
            Sortable,
            draggable
        },
        data() {
            return {
                bool_CV: false, // Check Validation
                bool_bankCV: false, // Check Bank Validation
                bool_PMCV: false, // Check paymentMethod Validation
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false, //Loading Visible
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_isRMV: false, // Reject Modal Visible
                bool_isABA: false, // Add Bank Modal Visible
                bool_isPM: false, // Add Payment Method Modal Visible
                bool_isCrypto: false, // Add Bank Modal Visible
                bool_supprotPM: false, // Support payment method
                bool_showSearchBar: true,
                int_TI: 0,//Total Items
                int_RC: 100, //Row Count
                int_Page: 1,//current Page
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                selectedFile: null, //image
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true,
                str_FV: [{ F: "AGI" }, { F: "DI" }, { F: "CTS", FV: { startDate: "", endDate: "" } }, { F: "MI" }, { F: "TT", FV: 2 }, { F: "RS_in", FV: "1" }, { F: "CI_csv", FA: true }], //Filter Value
                arry_wl: [], //Withdraw list
                obj_aw: [], // add Withdraw
                dd_agentgroup: [],//agent group option
                dd_bank: [],
                dd_PaymentMethod: [],
                dd_currency: [],
                dd_bankacc: [],
                dd_PMbankacc: [],
                dd_FPGPaymentAcc: [],
                dd_rejectreason: [],
                ddMemberList: [],
                obj_Reject: {
                    "reason": null,
                    "reason2": ""
                },
                bool_showDetails: false,
                searchCreatedTS: { startDate: this.getTodayDate(), endDate: this.getTodayDate() },
                bool_showAllTransaction: false,
                arr_TransactionList: [],
                checkDetails: 1,
                obj_GetStartDate: {
                    ATS: "0001-01-01T00:00:00"
                },
                obj_GetEndDate: {
                    CTS: "0001-01-01T00:00:00",
                },
                obj_member: {},
                constAccessType: constAccessType,
                dd_dofs: [], // Domain Option for search
                obj_bank: {},
                obj_PaymentMethod: {},
                obj_bankacc: {},
                ErrBAAmount: "",
                editBankIndex: -1,
                AutoUpdateTO: null,
                arry_visitorMembers: [],
                arry_systemId: [],
                opened: [],
                defaultReportHeaders: ['NO', 'TN', 'BN', 'U', 'MBA', 'TA', 'OWN', 'RS', 'CTS'],
                reportHeaders: [],
                needResetHeaders: false,
                previewUrl: null,
                bool_fullPreview: false,
                bool_isDDMV: false,
                bool_OCAD: true,  // optional company account detail
                bool_showTDTL : false,
                str_TotalDailyTransactionLimit : 0,
            }
        },
        validations: {
            obj_bank: {
                BNI: { required },
                BAI: { required },
                TA: { decimal, required },
            },
            obj_PaymentMethod: {
                PMI: { required },
                BC: { required },
            },
            obj_aw: {
                MB: {
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto;
                    }),
                },
                MBA: {
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto;
                    }),
                },
                MBN: {
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto;
                    }),
                },
                TA: {
                    decimal,
                    required: requiredIf(function (vm) {
                        return !this.bool_isCrypto
                    }),
                },
                RR: {
                    required: requiredIf(function (vm) {
                        return this.bool_isRMV;

                    }),
                },
            }
        },
        beforeRouteLeave(to, from, next) {
            clearTimeout(this.AutoUpdateTO);
            next();
        },
        created() {
            this.reportHeaders = null;
            this.$parent.showSubMenu = 'W';
            this.$parent.showActiveMenu = 'W.SWDU';
            this.str_FV[0].FV = this.$route.query.agi;
            if (this.$route.query.ci) {
                this.str_FV[6].FV = [];
                this.str_FV[6].FV.push(this.$route.query.ci);

            }
            this.getWithdrawList();
            console.log(this.getUserInfo.IHMI);
            this.getAgentGroup();
            this.getCurrencyList();
            this.setThousandCurrency(false);
            this.AutoUpdate();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['getUserInfo', 'checkModuleAccess']),
            ...mapGetters('CurrencyInfo', ['getThousandCurrency']),
            IsAllowAutoWithdraw() {
                if (this.obj_aw.BankList && this.obj_aw.BankList.length > 0) {
                    return false;
                }
                const bank = this.getBankById(this.obj_bank['BNI'] || 0);

                if (!bank) {
                    return false;
                }

                const bankCode = bank.label2;
                const supportChannels = constADBBankSupportChannels[bankCode];

                if (!supportChannels) {
                    return false;
                }

                if (supportChannels.indexOf(this.obj_aw.MB.toUpperCase()) == -1) {
                    return false;
                }

                const acc = this.getBankAccById(this.obj_bank['BAI'] || 0);
                this.obj_bankacc = acc;
                return acc ? Boolean(acc.EAW) : false;
            },
        },
        methods: {
            ...mapActions('CurrencyInfo', ['setThousandCurrency']),
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            CheckingMember(agi, mi) {
                let routeData = this.$router.resolve({ path: '/M/ML/CheckingMember', query: { agi: agi, i: mi } });
                window.open(routeData.href, '_blank');
            },
            CurrencyChange(value) {
                this.setThousandCurrency(this.CheckIsThousandCurrency(value, this), this);
            },
            TextValueChange(type, event) {
                if (type == "R") {
                    this.obj_aw.R = event.target.value;
                }
            },
            onFileSelected(event) {
                this.selectedFile = this.validateFile(event, 0.2, [".jpg", ".jpeg", ".bmp", ".gif", ".png", ".webp"]);
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SWDU', 'W', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            closeReject() {
                this.bool_isRMV = !this.bool_isRMV;
                this.bool_CV = false;
            },
            closeAddBank() {
                this.bool_isABA = !this.bool_isABA;
                this.bool_bankCV = false;
                this.obj_bank = {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null
                }
                this.dd_bankacc = [];
                this.editBankIndex = -1;
                this.bool_showTDTL = false;
            },
            closeAddPaymentgateway() {
                this.bool_isPM = !this.bool_isPM;
                this.bool_PMCV = false;
                this.obj_PaymentMethod = {
                    PMI: null,
                    BC: null,
                    TA: null,
                    MC: null,
                    FPGACC: null,
                }
                this.dd_PMbankacc = [];
                //this.editBankIndex = -1;
            },
            addPaymentgateway() {
                this.obj_PaymentMethod = {
                    PMI: null,
                    BC: null,
                    TA: this.obj_aw.TA,
                    MC: null,
                    FPGACC: null,
                }
                this.bool_isPM = true;
                //this.editBankIndex = -1;
            },
            addBank() {
                this.obj_bank = {
                    BN: null,
                    BNI: null,
                    BAI: null,
                    BA: null,
                    TA: null,
                    IAW: false
                }
                this.bool_isABA = true;
                this.editBankIndex = -1;
            },
            saveBank() {
                var MINWithdraw = 0;
                var MAXWithdraw = 0;
                var MAXWithdrawPerDay = 0;
                var TotalWithdrawPerDay = 0;
                if (this.obj_bank.TA == 0) {
                    this.obj_bank.TA = null;
                }
                this.bool_bankCV = true;
                this.$v.obj_bank.$touch();
                if (!this.$v.obj_bank.$error) {
                    var exist = false;
                    if (!this.obj_aw.BankList) {
                        this.obj_aw.BankList = [];
                    }
                    for (var pt of this.dd_bank) {
                        if (pt.id == this.obj_bank['BNI']) {
                            this.obj_bank['BN'] = pt.label;
                            break;
                        }
                    }

                    for (var pt of this.dd_bankacc) {
                        if (pt.id == this.obj_bank['BAI']) {
                            this.obj_bank['BA'] = pt.label;
                            MINWithdraw = pt.MINWithdraw;
                            MAXWithdraw = pt.MAXWithdraw;
                            MAXWithdrawPerDay = pt.TotalWithdraw;
                            TotalWithdrawPerDay = pt.TotalTransAmount;
                            break;
                        }
                    }

                    if (MINWithdraw != 0 && this.obj_bank.TA < MINWithdraw) {
                        return this.showErrorMessage(this.utilGetErrorLanguage("GL.TMINMAXW"), this.utilGetErrorLanguage("GL.MINMAXW"));
                    }

                    if (MAXWithdraw != 0 && this.obj_bank.TA > MAXWithdraw) {
                        return this.showErrorMessage(this.utilGetErrorLanguage("GL.TMINMAXW"), this.utilGetErrorLanguage("GL.MINMAXW"));
                    }

                    if (MAXWithdrawPerDay > 0 && (parseFloat(this.obj_bank.TA) + TotalWithdrawPerDay) > MAXWithdrawPerDay) {
                        return this.showErrorMessage(this.utilGetErrorLanguage("GL.TMINMAXW"), this.utilGetErrorLanguage("GL.MINMAXW"));
                    }

                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        if (this.obj_aw.BankList[i].BAI == this.obj_bank.BAI && this.editBankIndex != i) {
                            exist = true;
                            break;
                        }
                    }
                    if (!exist && this.editBankIndex != -1) {
                        this.obj_aw.BankList[this.editBankIndex] = this.obj_bank;
                        this.bool_isABA = false;
                        this.bool_bankCV = false;
                        this.obj_bank = {};
                        this.dd_bankacc = [];
                        this.editBankIndex = -1;

                        this.obj_PaymentMethod = {};
                        this.obj_aw.PaymentGatewayList = null;
                    }
                    else if (exist) {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1002'), this.getLanguage["MTA"]["BAN"]), 1000);
                    }
                    else {
                        this.obj_aw.BankList.push(this.obj_bank);
                        this.bool_isABA = false;
                        this.bool_bankCV = false;
                        this.obj_bank = {};
                        this.dd_bankacc = [];
                        this.editBankIndex = -1;

                        this.obj_PaymentMethod = {};
                        this.obj_aw.PaymentGatewayList = null;
                    }
                }
            },
            savePaymentGateway() {

                this.bool_PMCV = true;
                this.$v.obj_PaymentMethod.$touch();
                if (!this.$v.obj_PaymentMethod.$error) {


                    this.obj_aw.PaymentGatewayList = this.obj_PaymentMethod;
                    this.bool_isPM = false;
                    this.bool_PMCV = false;
                    this.obj_PaymentMethod = {};
                    this.dd_PMbankacc = [];

                    this.obj_bank = {};
                    this.obj_aw.BankList = [];




                }
            },
            removeBank(index) {
                this.$delete(this.obj_aw.BankList, index);
                this.$forceUpdate();
            },
            editBank(data, index) {
                this.bool_bankCV = false;
                this.obj_bank = Object.assign({}, data);
                this.BankNameChange(this.obj_bank.BNI, true);
                this.bool_isABA = true;
                this.editBankIndex = index;
            },
            removePaymentGateway() {
                this.obj_aw.PaymentGatewayList = null;
                this.$forceUpdate();
            },
            editPaymentGateway(data) {
                this.bool_PMCV = false;
                this.obj_PaymentMethod = Object.assign({}, data);
                this.PaymentMethodChange(this.obj_PaymentMethod.PMI, true);
                this.bool_isPM = true;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getWithdrawList();
            },
            ViewPromo(id) {
                this.obj_GetStartDate.ATS = "";
                this.obj_GetEndDate.CTS = "";
                this.bool_fullLoading = true;
                var that = this;
                this.getDataApi(`/api/dc/gE/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.obj_GetEndDate.CTS = "";
                            that.setPromo_V(d.D, 'ed', id);
                        }
                    });
                this.getDataApi(`/api/dc/gS/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            if (d.D.GetATS[0] == null) {
                                that.getDataApi(`/api/dc/DT/${id}`,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        if (s) {
                                            that.obj_GetStartDate = "";
                                            that.setPromo_V(d.D.GetDepositTS, 'dd', id);
                                        }
                                    });
                            }
                            else {
                                that.obj_GetStartDate = "";
                                that.setPromo_V(d.D, 'sd', id);

                            }
                        }
                    });

            },
            setPromo_V(data, name, id) {
                if (name == 'sd') {
                    //promo
                    this.obj_GetStartDate = Object.assign(this.obj_GetStartDate, data.GetATS[0]);
                    this.checkDetails = 1;
                }
                else if (name == 'dd') {
                    this.obj_GetStartDate = {
                        //deposit
                        //ATS: data[0].CTS,
                        ATS: data,
                    };
                }
                else {
                    //withdraw
                    this.obj_GetEndDate = Object.assign(this.obj_GetEndDate, data);
                    this.checkDetails = 2;
                }
                this.bool_showDetails = true;
                this.searchCreatedTS.endDate = this.obj_GetEndDate.CTS;
                this.searchCreatedTS.startDate = this.obj_GetStartDate.ATS;
                if (this.obj_GetEndDate.CTS && this.obj_GetStartDate.ATS)
                    this.getTransactionData(id);
                this.getData(id);
            },
            getData(id) {
                var that = this;
                that.bool_fullLoading = true;
                this.getDataApi(`/api/dc/gmbc/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.obj_member = Object.assign(that.obj_member, d.D);
                        }
                    });
            },
            getTransactionData(id) {
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                var hasDefaultPath = false;

                if (path) {
                    hasDefaultPath = true;
                }
                path += "&f.RT=1";
                path += "&f.MI=" + id;
                path += "&f.STS_from=" + this.obj_GetStartDate.ATS;
                path += "&f.STS_to=" + this.obj_GetEndDate.CTS;

                // path += "&f.TT=1";
                // path += "&f.I=" + id;
                // path += "&f.StartDate=" + this.obj_GetStartDate.ATS;
                // path += "&f.EndDate=" + this.obj_GetEndDate.CTS;

                if (!hasDefaultPath && path) {
                    path = path.substring(1);
                }
                this.arr_TransactionList = [];

                var that = this;
                this.bool_fullLoading = true;
                this.getDataApi(`/api/dc/lgt?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        that.bool_showAllTransaction = false;
                        that.bool_showMoreTransactionBtn = false;

                        if (s) {
                            if (d.D != null) {
                                that.int_TP = 1;
                                that.int_Total = d.D.length;
                                that.arr_TransactionList = d.D;

                                if (that.int_RC == 50) {
                                    that.bool_showAllTransaction = that.int_Total > 50;
                                }
                                else if (that.int_Total > 5) {
                                    that.bool_showMoreTransactionBtn = false;
                                }
                            }
                        }
                    });
            },
            newSearch() {
                if (!this.bool_isAMV && !this.bool_isRMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getWithdrawList();
                }
            },
            getCurrencyList() {
                var that = this;
                var agi = 0;

                if (this.searchPAgi) {
                    agi = this.searchPAgi;
                }
                this.getDataApi(`/api/dd/currency/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.dd_currency = d.dropdownlist;
                        }
                    });
            },
            getAgentGroup() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }
                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            BankNameChange(value, isEdit = false) {
                if (value != undefined) {
                    if (!isEdit) {
                        this.obj_bank['BAI'] = null;
                    }
                    this.dd_bankacc = [];
                    var that = this;
                    this.getDataApi(`/api/dd/withdrawbankacc/` + value + "/" + this.obj_aw.AGI + "/2/" + this.obj_aw.CI,
                        function (d, s) {
                            if (s) {
                                that.dd_bankacc = d.dropdownlist;
                                that.$forceUpdate();
                            }
                        });
                    this.bool_showTDTL = false;
                    this.obj_bank['BAI'] = null;
                }
            },
            BankAccountChange(value) {
                if (value) {
                    const bankAcc = this.dd_bankacc.find(f => f.id == value);
                    if (bankAcc) {
                        this.bool_showTDTL = bankAcc.TD > 0;
                        if (this.bool_showTDTL) {
                            if (bankAcc.TUD >= bankAcc.TD)
                                this.str_TotalDailyTransactionLimit = "<span class='text-danger'>" + this.ThousandSeparator(bankAcc.TUD, this.getThousandCurrency ? 3 : 2) + "</span> / " + this.ThousandSeparator(bankAcc.TD, this.getThousandCurrency ? 3 : 2);
                            else
                                this.str_TotalDailyTransactionLimit = this.ThousandSeparator(bankAcc.TUD, this.getThousandCurrency ? 3 : 2) + " / " + this.ThousandSeparator(bankAcc.TD, this.getThousandCurrency ? 3 : 2);
                        }
                    }
                }
            },
            PaymentMethodChange(value, isEdit = false) {
                if (value != undefined) {
                    if (!isEdit) {
                        this.obj_PaymentMethod['BC'] = null;
                        this.obj_PaymentMethod['FPGACC'] = null;
                    }

                    if (this.dd_PaymentMethod != null) {
                        for (var dd_PaymentMethod1 of this.dd_PaymentMethod) {
                            if (dd_PaymentMethod1.id == value) {
                                this.obj_PaymentMethod['MC'] = dd_PaymentMethod1.extra;
                                this.obj_PaymentMethod['PMN'] = dd_PaymentMethod1.label;
                            }
                        }
                    }
                    this.dd_PMbankacc = [];
                    var that = this;
                    this.getDataApi(`/api/dd/withdrawpmbankacc/` + value,
                        function (d, s) {
                            if (s) {
                                that.dd_PMbankacc = d.dropdownlist;
                                that.$forceUpdate();
                            }
                        });

                    if (value == 46) {
                        this.dd_FPGPaymentAcc = [];
                        this.getDataApi(`/api/dd/fpgpaymentacc/` + this.obj_aw.AGI, (d, s) => {
                            if (s) {
                                this.dd_FPGPaymentAcc = d.dropdownlist;
                                this.$forceUpdate();
                            }
                        });
                    }
                }
            },
            loadMemberOptions({ action, searchQuery, callback }) {
                var that = this;

                if (searchQuery == null || searchQuery == '' || searchQuery.trim() == '' || searchQuery.trim().length < 3) {
                    that.ddMemberList = null;
                    callback(this.getLanguage['MEM']['PS3']);
                }
                else {
                    var agi = 0;
                    if (this.str_FV[0].FV) {
                        agi = this.str_FV[0].FV.split("-")[1];
                    }
                    searchQuery = encodeURIComponent(searchQuery);
                    this.getDataApi(`/api/dd/mreferral/0/${searchQuery}/${agi}`,
                        function (d, s) {
                            if (s && d && d.dropdownlist) {
                                that.ddMemberList = d.dropdownlist;
                            }
                            else {
                                that.ddMemberList = [];
                            }

                            callback(null, that.ddMemberList);
                        });
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var that = this;
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }

                    this.getDataApi(`/api/dd/dn/` + agi,
                        function (d, s) {
                            if (s) {
                                that.dd_dofs = d.dropdownlist
                            }
                        });

                } else {
                    this.searchPAgi = 0;
                    this.str_FV[0].FV = null;
                }
                this.str_FV[6].FV = null;
                this.dd_currency = null;
                this.getCurrencyList();
            },
            getWithdrawList(isAutoUpdate = false) {
                this.bool_fullLoading = !isAutoUpdate;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);

                for (var i = 0; i < this.str_FV.length; i++) {
                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].FA && this.str_FV[i].FV) {
                            var temp_ = "";
                            for (var x = 0; x < this.str_FV[i].FV.length; x++) {
                                if (x != 0) {
                                    temp_ += ",";
                                }
                                temp_ += this.str_FV[i].FV[x];
                            }
                            path += ("f[" + this.str_FV[i].F + "]=" + temp_);
                        }
                        else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else if (this.str_FV[i].F == 'AGI' && this.str_FV[i].FV != '') {
                            var agi = 0;
                            var value = this.str_FV[i].FV;
                            if (value != "") {
                                agi = value.split("-")[1];
                            }
                            path += "&f[AGI]=" + agi;

                        }
                        else {
                            path += ("f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV);
                        }
                    }
                };
                this.getDataApi(`/api/agtrans/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setWithdrawList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setWithdrawList(data) {
                this.arry_wl = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            CalculateRemainAmount(TA, CS) {
                if (this.obj_aw.BankList != null) {
                    var amount = 0;
                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        amount += parseFloat(this.obj_aw.BankList[i].TA);
                    }
                    TA -= amount;
                    return this.formatNumber(TA, 2, CS);
                }
                else {
                    return this.formatNumber(TA, 2, CS);
                }
            },
            ValidationBankErrMsg(value, langKey = "") {
                if (this.bool_bankCV) {
                    var validateObj = this.$v.obj_bank[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            ValidationPMBankErrMsg(value, langKey = "") {
                if (this.bool_PMCV) {
                    var validateObj = this.$v.obj_PaymentMethod[value];
                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {
                    var validateObj = this.$v.obj_aw[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"][langKey]);
                    }
                    else if (validateObj.decimal != undefined && !validateObj.decimal) {
                        return String.format(this.utilGetErrorLanguage('1007'), this.getLanguage["MTA"][langKey]);
                    }
                }
            },
            approveWithdraw() {

                this.bool_CV = true;
                this.ErrBAAmount = "";

                var transAmount = 0;

                if (this.obj_aw.BankList) {
                    for (var i = 0; i < this.obj_aw.BankList.length; i++) {
                        transAmount += parseFloat(this.obj_aw.BankList[i].TA);
                        if (Boolean(this.obj_aw.BankList[i].IAW) == true) {
                            this.obj_aw.IAW = 1;
                        }
                    }
                    if (this.obj_aw.BankList.length > 1) {
                        this.obj_aw.IAW = 0;
                    }
                } else if (this.bool_OCAD) {
                    transAmount = this.obj_aw.TA;
                }

                if (!this.obj_aw.BankList && this.obj_aw.PaymentGatewayList == null && !this.bool_OCAD) {
                    this.ErrBAAmount = String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["MTA"]["CAD"]);;
                }
                else if (transAmount.toFixed(this.getThousandCurrency ? 3 : 2) != parseFloat(this.obj_aw.TA.toFixed(this.getThousandCurrency ? 3 : 2)) &&
                    this.obj_aw.PaymentGatewayList == null) {
                    this.ErrBAAmount = this.getLanguage["MTA"]["ErrAmount"];
                }
                else if (this.obj_aw.IAW == 1 && this.obj_bankacc && constADBBankAccountBalanceLimit > this.obj_bankacc.extra) {
                    this.ErrBAAmount = this.getLanguage["MTA"]["BALISF"];
                }
                else {
                    this.obj_aw.RURL = this.selectedFile;
                    //this.obj_ad["RURL"] = this.selectedFile;
                    this.$v.obj_aw.$touch();
                    if (!this.$v.obj_aw.$error) {

                        this.$fire({
                            title: this.getLanguage["MTA"]["CA"],
                            width: '30em',
                            showCancelButton: true,
                            confirmButtonText: this.getLanguage["GL"]["YES"],
                            cancelButtonText: this.getLanguage["CNO"]["NO"],
                            reverseButtons: true,
                            keydownListenerCapture: true,
                            customClass: {
                                title: 'afb-alert-title',
                                content: 'afb-alert-content',
                                actions: 'afb-alert-action'
                            }
                        }).then((result) => {
                            if (result.value == true) {
                                var that = this;
                                this.bool_fullLoading = true;
                                this.bool_fullScreen = true;
                                this.obj_aw['AC'] = 2;
                                this.obj_aw['RS'] = 2;
                                this.obj_aw['IITO'] = 0;
                                this.obj_aw['WSRT'] = "::[MTA][WST]::";
                                this.obj_aw['WSRM'] = "::[MTA][WSM]::";
                                this.postDataApiWithAttach(`/api/memtrans/ap`, this.obj_aw,
                                    function (d, s) {
                                        that.bool_fullLoading = false;
                                        that.bool_fullScreen = false;
                                        if (s) {
                                            if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 9001) {
                                                that.$fire({
                                                    title: that.getLanguage["MTA"]["CA"],
                                                    html: that.getLanguage["MTA"]["CIITO"],
                                                    width: '30em',
                                                    showCancelButton: true,
                                                    confirmButtonText: 'Ok',
                                                    cancelButtonText: 'Cancel',
                                                    reverseButtons: true,
                                                    keydownListenerCapture: true,
                                                    allowEnterKey: true,
                                                    customClass: {
                                                        title: 'afb-alert-title',
                                                        content: 'afb-alert-content',
                                                        actions: 'afb-alert-action'
                                                    }
                                                }).then((result) => {
                                                    if (result.value == true) {
                                                        that.bool_fullLoading = true;
                                                        that.obj_aw['IITO'] = 1;

                                                        that.postDataApiWithAttach(`/api/memtrans/ap`, that.obj_aw,
                                                            function (d, s) {
                                                                that.bool_fullLoading = false;
                                                                if (s) {
                                                                    that.bool_isAMV = false;
                                                                    that.ErrBAAmount = "";
                                                                    that.getWithdrawList();
                                                                }
                                                            });
                                                    }
                                                });
                                            }
                                            else {
                                                that.bool_isAMV = false;
                                                that.ErrBAAmount = "";
                                                that.getWithdrawList();
                                            }
                                        }
                                    });
                            }
                        });
                    }
                }
            },
            approveCryptoWithdraw() {

                this.bool_CV = true;
                this.ErrBAAmount = "";

                var transAmount = 0;
                this.$v.obj_aw.$touch();
                if (!this.$v.obj_aw.$error) {

                    this.$fire({
                        title: this.getLanguage["MTA"]["CA"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;
                            this.bool_fullLoading = true;
                            this.obj_aw['AC'] = 2;
                            this.obj_aw['RS'] = 2;
                            this.obj_aw['IITO'] = 0;
                            this.obj_aw['WSRT'] = "::[MTA][WST]::";   //this.getLanguage["MTA"]["WST"];
                            this.obj_aw['WSRM'] = "::[MTA][WSM]::";   //this.getLanguage["MTA"]["WSM"];

                            this.postDataApi(`/api/agtrans/ap`, this.obj_aw,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    if (s) {
                                        if (d.ERR && d.ERR.length > 0 && d.ERR[0].ERRC == 9001) {
                                            that.$fire({
                                                title: that.getLanguage["MTA"]["CA"],
                                                html: that.getLanguage["MTA"]["CIITO"],
                                                width: '30em',
                                                showCancelButton: true,
                                                confirmButtonText: 'Ok',
                                                cancelButtonText: 'Cancel',
                                                reverseButtons: true,
                                                customClass: {
                                                    title: 'afb-alert-title',
                                                    content: 'afb-alert-content',
                                                    actions: 'afb-alert-action'
                                                }
                                            }).then((result) => {
                                                if (result.value == true) {
                                                    that.bool_fullLoading = true;
                                                    that.obj_aw['IITO'] = 1;
                                                    that.postDataApi(`/api/agtrans/ap`, that.obj_aw,
                                                        function (d, s) {
                                                            that.bool_fullLoading = false;
                                                            if (s) {
                                                                that.bool_isAMV = false;
                                                                that.ErrBAAmount = "";
                                                                that.getWithdrawList();
                                                                that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                                            }
                                                        });
                                                }
                                            });
                                        }
                                        else {
                                            that.bool_isAMV = false;
                                            that.ErrBAAmount = "";
                                            that.getWithdrawList();
                                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                        }
                                    }
                                });
                        }
                    });
                }
            },
            rejectWithdraw() {
                this.bool_CV = true;

                var rejectreason = this.obj_Reject.reason == 999 ? this.obj_Reject.reason2 : this.obj_Reject.reason;

                if (rejectreason != "" && rejectreason != null) {

                    this.$fire({
                        title: this.getLanguage["MTA"]["CR"],
                        width: '30em',
                        showCancelButton: true,
                        confirmButtonText: this.getLanguage["GL"]["YES"],
                        cancelButtonText: this.getLanguage["CNO"]["NO"],
                        reverseButtons: true,
                        keydownListenerCapture: true,
                        customClass: {
                            title: 'afb-alert-title',
                            content: 'afb-alert-content',
                            actions: 'afb-alert-action'
                        }
                    }).then((result) => {
                        if (result.value == true) {
                            var that = this;

                            this.bool_fullLoading = true;
                            this.bool_fullScreen = true;
                            this.obj_aw['RR'] = rejectreason;
                            this.obj_aw['AC'] = 3;
                            this.obj_aw['RS'] = 3;
                            this.obj_aw['WSRT'] = this.getLanguage["MTA"]["WRT"];
                            this.obj_aw['WSRM'] = this.getLanguage["MTA"]["WRM"];


                            this.obj_aw['WSRT'] = "::[MTA][WRT]::";
                            this.obj_aw['WSRM'] = "::[MTA][WRM]::";


                            this.postDataApi(`/api/agtrans/ap`, this.obj_aw,
                                function (d, s) {
                                    that.bool_fullLoading = false;
                                    that.bool_fullScreen = false;
                                    if (s) {
                                        that.bool_isRMV = false;
                                        that.getWithdrawList();
                                    }
                                });
                        }
                    });
                }
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;
                this.getWithdrawList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            getbgtooltip(data) {
                var bgColor = '#FFF';
                var textColor = '#000';
                if (data) {
                    if (data.TBC) {
                        bgColor = data.TBC;
                    }

                    if (data.TC) {
                        textColor = data.TC;
                    }
                }
                return {
                    backgroundColor: bgColor, color: textColor, padding: '0px 5px', borderRadius: '5px'
                };
            },
            renderAssignedToColor(assignedTo) {
                return this.$parent.checkpendingColor(assignedTo);
            },
            renderAssignedTo(assignedTo, assignedToPrefixCode) {
                if (assignedTo == "") {
                    return this.getLanguage["GL"]["PEND"];
                } else {
                    return assignedTo + " (" + assignedToPrefixCode + ")";
                }
            },
            renderStatus(int_status) {
                switch (int_status) {
                    case 2:
                        return this.getLanguage["GL"]["APRD"];
                        break;
                    case 3:
                        return this.getLanguage["GL"]["REJD"];
                        break;
                    default:
                        return this.getLanguage["GL"]["PEND"];
                        break;
                }
            },
            renderStatusColor(int_status) {
                switch (int_status) {
                    case 2:
                        return "success";
                        break;
                    case 3:
                        return "danger";
                        break;
                    default:
                        return "dark";
                        break;
                }
            },
            renderStatusStyle(TA, TO) {
                if (TA > TO) {
                    return { 'font-weight': 'bold', color: '#d40000' };
                }
                else {
                    return { 'font-weight': 'bold', color: '#057b00' };
                }
            },
            assignWithdrawRequest(bool_isTakeover, d, index) {
                this.bool_fullLoading = true;
                var that = this;

                var dt = {
                    I: d.I,
                    UTS: d.UTS,
                    AC: bool_isTakeover ? 11 : 12
                };

                this.postDataApi(`/api/agtrans/ao`, dt,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.$refs["dd_assignto_" + index][0].visible = false;
                            that.getWithdrawList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },
            changeApproval(bool_isApproved, d, index) {
                this.bool_CV = false;
                if (bool_isApproved) {
                    this.obj_aw = Object.assign({}, d);
                    this.bool_fullLoading = true;
                    var that = this;
                    that.CurrencyChange(this.obj_aw.CS);
                    //// withdrawal with auto deposit bank return
                    this.getDataApi(`/api/dd/bank/` + this.obj_aw.AGI + "/4/" + this.obj_aw.CI,
                        function (d, s) {
                            if (s) {
                                that.dd_bank = d.dropdownlist;
                            }
                        });

                    this.getDataApi(`/api/dd/paymentg/` + this.obj_aw.AGI + "/" + this.obj_aw.CI,
                        function (d, s) {
                            if (s) {
                                that.dd_PaymentMethod = d.dropdownlist;
                                if (that.dd_PaymentMethod.length > 0) {
                                    that.bool_supprotPM = true
                                } else {
                                    that.bool_supprotPM = false
                                }
                            }
                        });

                    if (this.obj_aw.BNI == null || this.obj_aw.BNI == 0) {
                        this.obj_aw.BNI = null;
                        this.obj_aw.BAI = null;
                    }
                    this.OptionalCompanyBankDetail(this.obj_aw.AGI);
                    this.bool_isAMV = true;
                    this.bool_fullLoading = false;
                    this.bool_isCrypto = true;
                    //this.approveWithdraw();

                } else {
                    this.obj_aw = Object.assign({}, d);
                    this.dd_rejectreason = constRejectReasonSW;
                    this.obj_Reject = {
                        reason: null,
                        reason2: ""
                    };
                    this.bool_isRMV = true;
                }
            },
            changeCryptoApproval(bool_isApproved, d, index) {
                this.bool_CV = false;
                if (bool_isApproved) {
                    this.obj_aw = Object.assign({}, d);

                    this.bool_isCrypto = true;
                    this.approveCryptoWithdraw();

                } else {
                    this.obj_aw = Object.assign({}, d);
                    this.dd_rejectreason = constRejectReasonSW;
                    this.obj_Reject = {
                        reason: null,
                        reason2: ""
                    };
                    this.bool_isRMV = true;
                }
            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            OptionalCompanyBankDetail(agi) {
                var that = this;
                this.getDataApi(`/api/memtrans/reqcad/${agi}`,
                    function (d, s) {
                        if (s) {
                            that.bool_OCAD = d;
                        }
                    });
            },
            AutoUpdate() {
                this.nextUpdate();
                var that = this;
                this.AutoUpdateTO = setTimeout(function () {
                    that.AutoUpdate();
                }, 10000);
            },
            nextUpdate: function () {
                this.getWithdrawList(true);
            },
            toggleFingPrintId(data, aRow, bRow) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.UBI;
                path += "&f[FPJI]=" + data.SI;
                path += "&f[AGI]=" + data.AGI;

                const index = that.opened.indexOf(aRow + '_' + bRow);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsiu/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_visitorMembers[aRow + '_' + bRow] = d.D.Items;
                                that.opened.push(aRow + '_' + bRow)
                            }
                        });
                }
            },
            getSystemId(data) {
                var that = this;
                var path = this.getListingParamQuery(1, 50, this.str_tableSortBy, this.bool_isSort);

                path += "&f[MI]=" + data.MI;

                const index = that.opened.indexOf(data.I);

                if (index > -1) {
                    that.opened.splice(index, 1)

                } else {
                    this.getDataApi(`/api/m/gsi/?${path}`,
                        function (d, s) {
                            if (s) {
                                that.arry_systemId[data.I] = d.D.Items;
                                that.opened.push(data.I)
                            }
                        });
                }
                this.resizeTableHead()
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
            renderClassName(header, data) {
                if (header == 'U') {
                    return "kema-eft";
                } else if (header == 'TA') {
                    return "tableCtnRight";
                }
            },
            resetColumn(headerName) {
                var that = this;
                for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                    that.$set(that.reportHeaders, i, that.defaultReportHeaders[i])
                }
                this.resizeTableHead();
            },
            removeColumn(headerName) {
                var that = this;
                const index = that.reportHeaders.indexOf(headerName);
                if (index > -1)
                    that.reportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            removeDefaultColumn(headerName) {
                var that = this;
                const index = that.defaultReportHeaders.indexOf(headerName);
                if (index > -1)
                    that.defaultReportHeaders.splice(index, 1);
                this.resizeTableHead();
            },
            setPreview(img) {
                this.previewUrl = img;
                this.bool_fullPreview = true;
            },
            closeAdd1() {
                this.previewUrl = null;
                this.bool_fullPreview = !this.bool_fullPreview;
            },
            getBankById(id) {
                let index = -1;
                if (!this.dd_bank || this.dd_bank.length == 0) {
                    return null;
                }

                for (let i = 0; i < this.dd_bank.length; i++) {
                    if (this.dd_bank[i].id == id) {
                        index = i;
                        break;
                    }
                }

                if (index != -1) {
                    return this.dd_bank[index];
                }

                return null
            },
            getBankAccById(id) {
                let index = -1;
                if (!this.dd_bankacc || this.dd_bankacc.length == 0) {
                    return null;
                }

                for (let i = 0; i < this.dd_bankacc.length; i++) {
                    if (this.dd_bankacc[i].id == id) {
                        index = i;
                        break;
                    }
                }

                if (index != -1) {
                    return this.dd_bankacc[index];
                }

                return null
            },
            changeAllowAutoWithdraw() {
                if (Boolean(this.obj_bank.IAW) == true) {
                    const remainAmt = this.obj_aw.TA
                    this.obj_bank.TA = remainAmt
                    return
                }

                this.obj_bank.TA = null;
            },
            goToPage() {
                this.$router.push("/W/WDU");
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            bool_isRMV() {
                if (!this.bool_isRMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getWithdrawList();
                this.getCurrencyList();
            },
            reportHeaders() {
                var that = this;
                if (this.reportHeaders == null) {
                    this.getDataApi(`/api/reports/gc/Withdraw`,
                        function (d, s) {
                            if (s) {
                                if (d == null) {
                                    that.reportHeaders = [];
                                    for (var i = 0; i < that.defaultReportHeaders.length; i++) {
                                        if (that.reportHeaders.indexOf(that.defaultReportHeaders[i]) == -1)
                                            that.reportHeaders.push(that.defaultReportHeaders[i]);
                                    }
                                }
                                else {
                                    try {
                                        that.reportHeaders = JSON.parse(d);
                                    } catch (e) {
                                        d += "]";
                                        that.reportHeaders = JSON.parse(d);
                                    }
                                }
                                // hide columns for unauthorized access users
                                if (!that.checkModuleAccess2(constAccessType.add)) {
                                    that.removeDefaultColumn('OWN')
                                    that.removeDefaultColumn('RS')
                                    that.removeColumn('OWN')
                                    that.removeColumn('RS')
                                }
                            }
                        });
                }
                else {
                    this.getDataApi(`/api/reports/sc/Withdraw/` + JSON.stringify(that.reportHeaders),
                        function (d, s) {
                            if (s) {

                            }
                        });
                }

                if (this.reportHeaders != null) {
                    if (that.defaultReportHeaders.length != that.reportHeaders.length)
                        that.needResetHeaders = true;
                    else
                        that.needResetHeaders = false;
                }
            }
        },

    }

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/Withdraw/SubAgentWithdraw.vue